import { Row, Col, Button, ButtonGroup, Alert, Checkbox, ControlLabel } from 'react-bootstrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";

import countriesObj from "../../../../data/countries";
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import React from 'react';

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

export default class PushapiPostbackForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            groupBy: {},
            country: "",
            affid: "",
            subid: "",
            hour: '',
            day: '',
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if (checked) {
            groupBy[name] = 1;
        } else {
            delete groupBy[name];
        }

        this.setState({ groupBy });
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm();
        const filters = Object.assign({}, { ...this.state, alert: null });

        filters.groupBy = Object.keys(filters.groupBy);

        if (filters.compareDay) filters.compare = 1;

        if (isValid) this.props.onSubmit(filters, type);
    }

    validateForm() {
        const { day, groupBy } = this.state;

        let alert = null;

        if (!day) {
            alert = 'Please set Day';
        } else if (!Object.keys(groupBy).length) {
            alert = 'Please select grouping';
        }

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if (alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}

                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>
                        <Checkbox onChange={this.handleGroupByChange} name="datetime">Datetime</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="affid">Affid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="subid">Subid</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="validity">Validity</Checkbox>
                    </Col>
                </Row>
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            max={new Date().toISOString().split('T')[0]}
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourFrom"
                            label="Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourTo"
                            label="Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourTo}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.affids}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.subids}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('load_report')}>Load</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('load_affid')}>Load Affid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('load_subid')}>Load Subid</Button>
                </ButtonGroup>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/PushapiPostbackHourly/components/Form/index.js